<app-tab-generic *ngIf="!areLoadingComponents" [componentsData]="components"></app-tab-generic>